var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) { return (_pushScopeId("data-v-32bdc399"), n = n(), _popScopeId(), n); };
var _hoisted_1 = { class: "inline-flex e-star-rating" };
var _hoisted_2 = ["onClick", "onMouseenter"];
import { computed, nextTick, ref } from 'vue';
import EIcon from '@common/ui/EIcon.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'EStarRating',
    props: /*#__PURE__*/ _mergeModels({
        max: { default: 5 },
        disabled: { type: Boolean, default: false },
        theme: { default: 'orange' },
        lastHalfed: { type: Boolean }
    }, {
        "modelValue": {},
        "modelModifiers": {},
    }),
    emits: /*#__PURE__*/ _mergeModels(["input", "change"], ["update:modelValue"]),
    setup: function (__props, _a) {
        var _this = this;
        var __emit = _a.emit;
        var props = __props;
        var emits = __emit;
        var modelValue = _useModel(__props, "modelValue");
        var hoveredStar = ref(null);
        var starsThemeClass = computed(function () { return ({
            orange: 'e-star--orange',
            green: 'e-star--green'
        })[props.theme]; });
        var isStarActive = function (star) {
            return hoveredStar.value !== null ? star <= hoveredStar.value : modelValue.value && star <= modelValue.value;
        };
        var isStarActiveHalfed = function (star) {
            return props.disabled && props.lastHalfed && modelValue.value && star === modelValue.value;
        };
        var selectStar = function (star) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (props.disabled) {
                            return [2 /*return*/, false];
                        }
                        modelValue.value = star;
                        return [4 /*yield*/, nextTick()];
                    case 1:
                        _a.sent();
                        emits('input', star);
                        emits('change', star);
                        return [2 /*return*/];
                }
            });
        }); };
        var onStarHover = function (star) {
            if (props.disabled) {
                return false;
            }
            hoveredStar.value = star;
        };
        var onStarLeave = function () {
            hoveredStar.value = null;
        };
        return function (_ctx, _cache) {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.max, function (star) {
                    return (_openBlock(), _createElementBlock("div", {
                        key: star,
                        class: _normalizeClass([[
                                starsThemeClass.value,
                                {
                                    'cursor-pointer': !_ctx.disabled,
                                    'active': isStarActive(star),
                                },
                            ], "e-star"]),
                        onClick: function ($event) { return (selectStar(star)); },
                        onMouseenter: function ($event) { return (onStarHover(star)); },
                        onMouseleave: onStarLeave
                    }, [
                        (isStarActiveHalfed(star))
                            ? (_openBlock(), _createBlock(EIcon, {
                                key: 0,
                                class: "w-2.5 h-5",
                                icon: "star-half"
                            }))
                            : (_openBlock(), _createBlock(EIcon, {
                                key: 1,
                                class: "w-5 h-5",
                                icon: "star-full"
                            }))
                    ], 42, _hoisted_2));
                }), 128))
            ]));
        };
    }
});
